import { render } from "./Formato1988.vue?vue&type=template&id=3d025c6e&scoped=true"
import script from "./Formato1988.vue?vue&type=script&lang=js"
export * from "./Formato1988.vue?vue&type=script&lang=js"

import "./Formato1988.vue?vue&type=style&index=0&id=3d025c6e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d025c6e"]])

export default __exports__